<template>
    <div>
    <b-button variant="primary" class="btn-block-xs-only" @click="startSaveCategory">
        <i class="fa fa-plus"></i> Agregar categorias
    </b-button>
    <b-table responsive v-if="tableData.length" striped hover :items="tableData" :fields="fields">
        <template slot="actions" slot-scope="{ item }">
            <b-button
            size="sm"
            variant="danger"
            title="Eliminar categoria"
            @click="startRemoveCategory(item)"
            >
                <i class="fa fa-trash"></i>
            </b-button>
        </template>
    </b-table>
    <div v-else>
        <b-alert show variant="info">Actualmente no tiene asignada ninguna categoria, ¡Agregue una!</b-alert>
    </div>

    <!-- inicio de pop ups -->
    <app-pop-up title="Formulario teléfono" id="assign-categories-form" :onClose="cleanForm">
        <div class="body" slot="body">
            <app-category-store-form :store="store" :onSave="onSave"/>
        </div>
        <div slot="buttons">
            <b-button
                variant="confirm"
                :disabled="inProgress"
                class="btn-block-xs-only"
                @click="$bus.$emit('assign-categories-form.save')"
                >
                <i class="fa fa-floppy-o"></i> Asignar Categorias
            </b-button>
        </div>
    </app-pop-up>

    <app-pop-up title="Confirmación" id="store-category-remove">
        <div slot="body">
            <h2>¿Esta seguro que desea eliminar esta categoria?</h2>
        </div>
        <div class="buttons" slot="buttons">
            <button class="btn btn-confirm" @click="unassignCategory(selectedCategory)">
                <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación
            </button>
        </div>
    </app-pop-up>
    <!-- Fin pop up's -->
    </div>
</template>

<script>
import CategoryStoreForm from "./CategoryStoreForm/CategoryStoreForm";
import storesRepository from "../../../../repositories/stores.repository.js";
import { mapGetters, mapMutations } from "vuex";
import * as mutations from "../../../../store/commitTypes";
export default {
    components: {
        appCategoryStoreForm: CategoryStoreForm
    },
    props: {
        store: {
            required: true
        }
    },
    data() {
        return {
            fields: [
                {
                    key: "name",
                    label: "Nombre",
                    filter: true
                },
                {
                    key: "actions",
                    label: ""
                }
            ],
            selectedCategory: ""
        };
    },
    computed: {
        ...mapGetters(["selectedStore"]),
        tableData() {
        if (!this.store || !this.store.store_categories) return [];
            return this.store.store_categories;
        }   
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        startRemoveCategory(category) {
            this.selectedCategory = Object.assign({}, category);
            this.$bus.$emit("store-category-remove.open");
        },
        startSaveCategory() {
            this.selectedCategory = "";
            this.$bus.$emit("assign-categories-form.open");
        },
        onSave(store) {
            this.setSelectedStore(store);
            this.$bus.$emit("assign-categories-form.close");
        },
        unassignCategory(category) {
            const payload = {};
            payload["storeId"] = this.store.id;
            payload["categoryId"] = category.id;

        const sr = { ...storesRepository };
        sr.unassignCategory(payload)
            .then(({ data }) => {
                if (data.status) {
                    const store = { ...this.selectedStore };
                    const index = store.store_categories.findIndex(
                        theCategory => parseInt(theCategory.id) === parseInt(category.id)
                    );
                    if (-1 != index) {
                        store.store_categories.splice(index, 1);
                        this.setSelectedStore(store);
                        toastr.success(data.msg);
                        this.$bus.$emit("store-category-remove.close");
                    }
                } else {
                    toastr.error(data.msg);
                }
            })
            .catch(error => {
                toastr.error("No se pudo borrar la categoria");
            });
        },
        cleanForm() {
            this.$bus.$emit("assign-categories.clean");
        }
    }
};
</script>
